export default "__VITE_ASSET__0bf56752__"